var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMapPinHexagonColor({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 70,
    height: 70,
    viewBox: "0 0 70 70",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M35 64C36.6569 64 38 65.3431 38 67C38 68.6569 36.6569 70 35 70C33.3431 70 32 68.6569 32 67C32 65.3431 33.3431 64 35 64Z",
    fill: "#FF8800"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M45.4854 2C46.5462 2.00004 47.5634 2.42177 48.3135 3.17188L60.8281 15.6865C61.5782 16.4366 62 17.4538 62 18.5146V39.4854C62 40.5462 61.5782 41.5634 60.8281 42.3135L48.3135 54.8281C47.5634 55.5782 46.5462 56 45.4854 56H45C41.0001 56 38.75 56.4444 37.25 59.4072C37.1039 59.6957 36.9791 59.9706 36.8633 60.2256C36.3843 61.2796 36.0568 62 35 62C33.9432 62 33.6157 61.2796 33.1367 60.2256C33.0209 59.9706 32.8961 59.6957 32.75 59.4072C31.25 56.4444 28.9999 56 25 56H24.5146C23.4538 56 22.4366 55.5782 21.6865 54.8281L9.17188 42.3135C8.42176 41.5634 8.00004 40.5462 8 39.4854V18.5146C8.00004 17.4538 8.42177 16.4366 9.17188 15.6865L21.6865 3.17188C22.4366 2.42177 23.4538 2.00004 24.5146 2H45.4854Z",
    fill: "#FF8800"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMapPinHexagonColor);
export default __webpack_public_path__ + "static/media/map_pin_hexagon_color.2e62da0f26b0f8826aedbef297e642a6.svg";
export { ForwardRef as ReactComponent };